<template>
  <f7-page>
    <f7-navbar
      class="bg-madai"
      :sliding="false"
      back-link
    >
      <f7-nav-title class="text-white">Diseño Personalizado</f7-nav-title>
    </f7-navbar>
    <f7-block-title class="bold">¿Qué tipo de joyería buscas configurar?</f7-block-title>
    <f7-block>
      <f7-row class="m-10 m-t-30">
        <f7-col>
          <f7-button href="/personalizado/compromiso/" class="h-200" style="text-transform: unset; line-height: inherit;" raised>
            <div class="m-b-0">
              <img class="wd-100 m-t-10" src="https://via.placeholder.com/150" alt="">
            </div>
            <div>Anillo de compromiso</div>
          </f7-button>
        </f7-col>
        <f7-col>
          <f7-button href="/personalizado/churumbela/" class="h-200" style="text-transform: unset; line-height: inherit;" raised>
            <div class="m-b-0">
              <img class="wd-100 m-t-10" src="https://via.placeholder.com/150" alt="">
            </div>
            <div>Churumbela</div>
          </f7-button>
        </f7-col>
      </f7-row>
      <f7-row class="m-10">
        <f7-col>
          <f7-button href="/personalizado/alternativo/" class="h-200" style="text-transform: unset; line-height: inherit;" raised>
            <div class="m-b-0">
              <img class="wd-100 m-t-10" src="https://via.placeholder.com/150" alt="">
            </div>
            <div>Tema Alternativo</div>
          </f7-button>
        </f7-col>
        <f7-col>
          <f7-button href="/personalizado/otro/" class="h-200" style="text-transform: unset; line-height: inherit;" raised>
            <div class="m-b-0">
              <img class="wd-100 m-t-10" src="https://via.placeholder.com/150" alt="">
            </div>
            <div>Otro</div>
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </f7-page>
</template>

<script>
export default {

}
</script>
